<template>
    <div class="animated fadeIn">
        <user-form v-if="showUserForm" v-bind:user="user" v-bind:mode="userInputMode" :is-deleted="true"></user-form>
        <div v-if="showUsers">
            <div class="viewMode">
                <b-row>
                    <b-col cols="12">
                        <h1>User Management</h1>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-card>
                            <div slot="header">
                                <strong>Current Deleted Users</strong>
                            </div>
                            <div v-if="!usersLoaded" class="form-container">
                                <LoadingSpinner />
                            </div>
                            <div v-if="usersLoaded" class="form-container">
                                <b-row>
                                    <b-col sm="4">
                                        <b-form-group>
                                            <label for="company">Company</label>
                                            <b-form-select id="company" v-if="companiesLoaded"  v-model="filterParams.company_id"
                                                :plain="true"
                                                :options="companies"
                                                :disabled="!isMinimumSuperAdmin">
                                            </b-form-select>
                                            <div v-if="!companiesLoaded" >
                                                <i class="fa fa-spin fa-spinner"></i>
                                            </div>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="4">
                                        <b-form-group>
                                            <label for="area">Area</label>
                                            <b-form-select id="area" v-if="areasLoaded"  v-model="filterParams.area_id"
                                                :plain="true"
                                                :options="areas"
                                                :disabled="!isMinimumCompanyUser">
                                            </b-form-select>
                                            <div v-if="!areasLoaded" >
                                            <i class="fa fa-spin fa-spinner"></i> Waiting for company selection
                                            </div>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="4">
                                        <b-form-group>
                                            <label for="site">Site</label>
                                            <b-form-select id="site" v-if="sitesLoaded"  v-model="filterParams.site_id"
                                                :plain="true"
                                                :options="sites"
                                                :disabled="!isMinimumAreaUser">
                                            </b-form-select>
                                            <div v-if="!sitesLoaded" >
                                            <i class="fa fa-spin fa-spinner"></i> Waiting for area selection
                                            </div>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="isFetchUsersButtonNeeded">
                                    <b-col cols="12" sm="12" md="12">
                                        <p>
                                        <b-button v-on:click="fetchUsers" variant="primary">
                                            <i class="fa fa-search"></i>&nbsp; Fetch Users
                                        </b-button>
                                        </p>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col v-if="filteredUsersLoaded" sm="3">
                                        <b-form-group>
                                            <label for="tableFilter">Filter</label>
                                            <b-form-input v-model="tableFilter" type="text" id="tableFilter"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col v-if="!isFirstEntry" cols="12">
                                        <div v-if="!filteredUsersLoaded" class="form-container">
                                            <LoadingSpinner />
                                        </div>
                                        <div v-if="filteredUsersLoaded" id="customer-list">
                                            <!--<c-table :filter="tableFilter" :table-data="contactItems" :fields="tableFields" :perPage="10" hover bordered caption="All Contacts"></c-table>-->
                                            <b-table
                                                id="users-table"
                                                class="datalist-table"
                                                selectable
                                                hover
                                                bordered
                                                select-mode="single"
                                                :items="userItems"
                                                :fields="tableFields"
                                                :filter="tableFilter"
                                                :per-page="tablePerPage"
                                                :current-page="tableCurrentPage"
                                                @row-clicked="rowSelected"
                                                responsive="sm"
                                                >
                                            </b-table>
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col v-if="filteredUsersLoaded" md="6" class="my-1">
                                        <b-pagination
                                        v-model="tableCurrentPage"
                                        :total-rows="tableTotalRows"
                                        :per-page="tablePerPage"
                                        class="my-0"
                                        ></b-pagination>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>

  import LoadingSpinner from '../../components/loadingSpinner/LoadingSpinner'
  import { Switch as cSwitch } from '@coreui/vue'
  import cTable from '../../components/table/Table'
  import UserForm from '../../components/forms/User'

  const getHTTPHeaders = () => {
    let userObj = JSON.parse(localStorage.getItem('user'));
    return {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Bearer ' + userObj.token,
      }
    };
}

const getCurrentUser = () => {
    return new Promise((resolve, reject) => {
        let user = JSON.parse(localStorage.getItem('user'));
        if (user != null) {
            resolve(user);
        }
        else {
            reject();
        }

    });
}

const getUsers = (($http, params) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        let url = 'users?company_id=' + params.company_id;
        if (parseInt(params.area_id) > 0) {
            url += '&area_id=' + params.area_id;
        }
        if (parseInt(params.site_id) > 0) {
            url += '&site_id=' + params.site_id;
        }
        url += '&is_deleted=1';
        $http.get(url, headersObj)
            .then((response) => {
                resolve(response.data.users);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getUserGroups = (($http) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get('getRolesForSelect', headersObj)
            .then((response) => {
                resolve(response.data.groups);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getSiteList = (($http, areaId) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get('getSitesForSelect?area_id=' + areaId, headersObj)
            .then((response) => {
                resolve(response.data.sites);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getCompaniesList = (($http) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
         $http.get('getCompaniesForSelect', headersObj)
            .then((response) => {
                // let companies = response.data.companies.map((element) => {
                //     let newElement = {
                //         value: element.id,
                //         text: element.company_name
                //     };
                //     return newElement;
                // });
                resolve(response.data.companies);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getAreaList = (($http, companyId) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
         $http.get('getAreasForSelect?company_id=' + companyId, headersObj)
            .then((response) => {
                resolve(response.data.areas);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});


export default {
  name: 'SystemUsersAdmin',
  components: {
      LoadingSpinner: LoadingSpinner,
      cSwitch,
      cTable,
      UserForm
  },
  data () {
    return {
        user: null,
        userAuthLevel : '',
        userAuthCode : '',
        saveError: false,
        saveInProgress: false,
        deleteSuccess: false,
        showUsers: true,
        showUserForm: false,
        saveSuccess: false,
        userObj: {},
        usersLoaded: false,
        filteredUsersLoaded: false,
        userGroupsLoaded: false,
        userItems: [],
        userGroups: [],
        userGroupsForSelect: [],
        companies: [],
        companiesLoaded: false,
        sites: [],
        sitesLoaded: false,
        areas: [],
        areasLoaded: false,
        tableFilter: '',
        tablePerPage: 20,
        tableCurrentPage: 1,
        tableTotalRows: 0,
        tableFields: [
            {key: 'first_name', label: 'First Name', sortable: true},
            {key: 'last_name', label: 'Last Name', sortable: true},
            {key: 'companyName', label: 'Group Name', sortable: true},
            {key: 'areaName', label: 'Branch Name', sortable: true},
            {key: 'siteName', label: 'Site Name', sortable: true},
            {key: 'email', label: 'Email', sortable: true},
            {key: 'roleName', label: 'Auth Group', sortable: true}
        ],
        userInputMode: 'add',
        filterParams: {
            company_id: -1,
            area_id: -1,
            site_id: -1,
        },
        isFirstEntry: true,
        isFetchUsersButtonNeeded: true,
    }
  },
  created () {
    this.getInitialData();
  },
  computed: {
    isUserSuperAdmin() {
        if (this.$data.userAuthLevel == 'Super Admin') {
            return true;
        }
        else {
            return false;
        }
    },
    isMinimumSuperAdmin() {
      let returnVal = false;
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      
      return returnVal;
    },
    isMinimumCompanyUser() {
      let returnVal = false;
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
        case 'Company Users':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      return returnVal;
    },
    isMinimumAreaUser() {
      let returnVal = false;
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
        case 'Company Users':
        case 'Area Users':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      // console.log('Area: ', returnVal);
      return returnVal;
    },
    isMinimumSiteUser() {
      let returnVal = false;
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
        case 'Company Users':
        case 'Area Users':
        case 'Site Users':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      
      return returnVal;
    },
    isUserReadOnly() {
        return (this.$data.userAuthLevel === 'Read Only');
    },
    isSiteSelectionEnabled() {
        console.log(this.$data.enableSiteSelection);
        return (this.isMinimumAreaUser && this.$data.enableSiteSelection);
    }
  },
  watch: {
      'filterParams.company_id': function(val, oldVal) {
    
        // get the branches for the selected company
        // clear it out first
        this.$data.areas = [];
        
        getAreaList(this.$http, val)
            .then((areaList) => {
                if (this.$data.userAuthLevel == 'Super Admin' || this.$data.userAuthLevel == 'Company Users') {
                    this.$data.areas.push({value:0, text: 'All Areas'});
                    this.$data.filterParams.area_id = 0;
                    this.$data.filterParams.site_id = 0;
                }
                areaList.map((item) => {
                    this.$data.areas.push(item);
                });
                this.$data.areasLoaded = true;
                
            })
            .catch ((err) => {
                console.error(err);
            }); 
    },
    'filterParams.area_id': function(val, oldVal) {

        // clear it out first
        this.$data.sites = [];
        this.$data.sites.push({value:0, text: 'All Sites'});
        this.$data.filterParams.site_id = 0;

        console.log(parseInt(val));
        
        if (parseInt(val) > 0) {
            getSiteList(this.$http, val)
            .then((sitesList) => {
                // if (this.$data.userAuthLevel == 'Super Admin' || this.$data.userAuthLevel == 'Company Users') {
                //     this.$data.sites.push({value:0, text: 'All Sites'});
                //     this.$data.filterParams.site_id = 0;
                //     this.$data.enableSiteSelection = false;
                // }
                sitesList.map((item) => {
                    this.$data.sites.push(item);
                });
                this.$data.sitesLoaded = true;
            })
            .catch ((err) => {
                console.error(err);
            }); 
        }
        
    },
    'filterParams.site_id': function(val, oldVal) {

        this.$data.filterParams.site_id = val;
        
    }
  },
  methods : {
    closeUserForm() {
      this.fetchUsers();
      this.$data.showUsers = true
      this.$data.showUserForm = false;
    },
    loadUserForm(user) {
      this.$data.user = user;
      this.$data.showUserForm = true;
      this.$data.showUsers = false;
      this.$data.userInputMode = 'edit';
    },
    rowSelected(item) {
        if(false === this.isUserReadOnly) {
          this.loadUserForm(item);
        }
    },
    getHTTPHeaders() {
      let user = JSON.parse(localStorage.getItem('user'));
      return {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization':  'Bearer ' + user.token,
          }
        };
    },
    getInitialData() {
        let userDetails = {};
        getCurrentUser(this.$http)
            .then((retuendUserDetails) => {
                userDetails = retuendUserDetails;
                this.$data.userAuthLevel = userDetails.auth;
                this.$data.userAuthCode = userDetails.authcode;
                if (userDetails.authcode === undefined) {
                    this.$router.push('/pages/login');
                }
                
                return getCompaniesList(this.$http)
            })
            .then((results) => {
                this.$data.companies = results;
                this.$data.companiesLoaded = true;

                return getUserGroups(this.$http);  
            })
            .then((groupList) => {
                this.$data.userGroups = groupList;

                this.$data.filterParams.company_id = userDetails.company_id;
                this.$data.filterParams.area_id = userDetails.area_id;
                this.$data.filterParams.site_id = userDetails.site_id;

                this.$data.usersLoaded = true;
                this.$data.userGroupsForSelect = this.$data.userGroups;
                this.$data.userGroupsLoaded = true;

                // if we're a site user or below, then we can auto fetch users because they can't filter anyway
                // ...and we can remove the fetch users button too.
                if (parseInt(this.$data.userAuthCode) >= 20) {
                    this.$data.isFetchUsersButtonNeeded = false;
                    this.fetchUsers();
                }

            })
            .catch ((err) => {
                console.error(err);
            });
    },
    fetchUsers() {
        // perform the fetch
        this.$data.filteredUsersLoaded = false;
        this.$data.isFirstEntry = false;
        getUsers(this.$http, this.$data.filterParams)
            .then((userList) => {
                // only show users on the same level or below
                // so sort the data to make sure
                // console.log(userList);
                this.$data.userItems = userList.filter((userObj) => {
                    userObj.roleName = userObj.roles[0].name;
                    userObj.companyName = userObj.company.company_name;
                    userObj.areaName = userObj.area.area_name;
                    userObj.siteName = userObj.site.site_name;
                    return parseInt(userObj.auth_level) >= parseInt(this.$data.userAuthCode);
                });
                // console.log(this.$data.userItems[0].approved);
                this.$data.tableTotalRows = this.$data.userItems.length;
                this.$data.filteredUsersLoaded = true;
            });
            
    },
    exitAddMode() {
        this.$data.newUser = this.resetUser()
        this.$data.groupsLoaded = false;
        this.$data.usersLoaded = false;
        this.$data.deleteSuccess = false;
        //this.getUsers();
    },
    clearAlerts() {
        this.$data.saveError = false;
        this.$data.saveInProgress = false;
    },
  }
}
</script>
